import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { ReportService } from 'src/shared/services/report.service';
import { Observable, Subscription, from } from 'rxjs';
import { ReportData } from 'src/shared/models/report-data.model';
import { ReportDataSet } from 'src/shared/models/report-dataset.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';

@Component({
  selector: 'smt-executive-variance-report',
  templateUrl: './executive-variance-report.component.html',
  styleUrls: ['./executive-variance-report.component.scss']
})

export class ExecutiveVarianceReportComponent implements OnInit {

  @Input() filtersUpdated: Observable<void>;
  @Input() reportFilters: ReportFilters;

  private filterEventSubscription: Subscription;
  reportSubscription: Subscription;
  varianceData: ReportData;
  sortableGridData: any = [];
  toggleSortGrid: boolean = false;
  gridData: ReportDataSet[];
  loading: boolean;

  constructor(private reportService: ReportService) { }

  ngOnInit() {
    this.loading = true;
    this.sortableGridData = [];
    this.varianceData = new ReportData();

    if (this.filtersUpdated)
      this.filterEventSubscription = this.filtersUpdated.subscribe(() => this.getData());

  }

  async getData() {
    this.loading = true;

    if (this.reportSubscription)
      this.reportSubscription.unsubscribe();

    this.reportSubscription = from(this.reportService.getExecutiveVarianceReport(this.reportFilters))
      .subscribe(reportData => {
        this.varianceData = reportData;
        this.gridData = MiscUtil.getDataFilteredByDataSetName(reportData);
        this.mapToSortableGridData();
        this.loading = false;
      });
  }

  sortByColumn(columnName: string) {
    this.toggleSortGrid = !this.toggleSortGrid;
    this.sortableGridData = this.sortableGridData.sort((a, b) => {
      let sortAscending = columnName != 'varianceTypeColumn' ? (+(a[columnName] === null)) - (+(b[columnName] === null)) || a[columnName] - b[columnName]
                           : a[columnName].toLowerCase() > b[columnName].toLowerCase() ? -1 : b[columnName].toLowerCase() > a[columnName].toLowerCase() ? 1 : 0;
      let sortDescending = columnName != 'varianceTypeColumn' ? (+(b[columnName] === null)) - (+(a[columnName] === null)) || b[columnName] - a[columnName]
                           : b[columnName].toLowerCase() > a[columnName].toLowerCase() ? -1 : a[columnName].toLowerCase() > b[columnName].toLowerCase() ? 1 : 0;
      return this.toggleSortGrid ? sortAscending : sortDescending;
    });
  }

  ngOnDestroy() {
    if (this.filterEventSubscription)
      this.filterEventSubscription.unsubscribe();
    if (this.reportSubscription)
      this.reportSubscription.unsubscribe();
  }

  private mapToSortableGridData() {
    let tableHeaders = this.varianceData.xAxis;
    this.sortableGridData = this.gridData.map(function (record) {
      let gridRecord = [];
      gridRecord['varianceTypeColumn'] = record.name;
      gridRecord['data'] = record.data;
      record.data.map(function (value, index) {
        gridRecord[tableHeaders[index]] = value;
      });
      return gridRecord;
    });
  }
}
